"use client";

import Script from "next/script";
import { Box, Grid, Container } from "@mui/material";

import { useUi } from "@/context/util/ui";

import { LoadingContainer, LoadingElements } from "@/components/loading";
import NavBar from "@/components/navBar";

export const PageLayout = ({ children }: { children: React.ReactNode }) => {
  const { backgroundColor, breadcrumbs } = useUi();

  return (
    <>
      {/* GA4 ECOSYSTEM SCRIPTS*/}
      <Script
        async
        src={`https://www.googletagmanager.com/gtag/js?id=${process.env.NEXT_PUBLIC_GAID}`}
      ></Script>
      <Script id="google-analytics">
        {`window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${process.env.NEXT_PUBLIC_GAID}');`}
      </Script>
      <NavBar />
      <Box
        sx={{
          backgroundColor,
          display: "flex",
          width: "100%",
          minHeight: "calc(100vh - 64px)",
        }}
      >
        <LoadingContainer />
        <Grid
          sx={{
            display: "flex",
            width: "100%",
            minHeight: "calc(100vh - 64px)",
          }}
          container
          flexDirection="column"
          justifyContent="flex-start"
        >
          <Container>
            {breadcrumbs}
            <LoadingElements />
            {children}
          </Container>
        </Grid>
      </Box>
    </>
  );
};
